var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-dialog',{attrs:{"closeOnClickOverlay":true,"showConfirmButton":false},model:{value:(_vm.visibleCardInfo),callback:function ($$v) {_vm.visibleCardInfo=$$v},expression:"visibleCardInfo"}},[_c('div',{staticClass:"goods-notice",domProps:{"innerHTML":_vm._s(_vm.goods.notice)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }